export default {
  handler: 'relativeUrl',
  data: ({ sportId }) => `/sports/${sportId}/next_event`,
};
